import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "@i18n/hooks";
import { Paths } from "@routes/paths";
import { type EditOrderButtonProps } from "./edit-order-button.types";

export const EditOrderButton = ({ orderId }: EditOrderButtonProps) => {
	const navigate = useNavigate();
	const { t } = useTranslation("common");

	return (
		<Button
			icon="pi pi-pencil"
			tooltip={t("order.editTooltip")}
			onClick={() => {
				navigate(Paths.orders.withId(orderId).edit.path);
			}}
		/>
	);
};
